import { useEffect, useState } from 'react';

export const useBuConfig = () => {
    const [buConfig, setBuConfig] = useState({
        operatingUnit: "",
        operatingCompany: ""
    });

    useEffect(() => {
        fetch(`${process.env.PUBLIC_URL}/buConfig.json`)
            .then((response) => response.json())
            .then((data) => {
                localStorage.setItem("nBisBuConfig", JSON.stringify(data))
                setBuConfig(data)
            })
            .catch((error) => {
                console.error("Failed to load config:", error);
            });
    }, []);

    return buConfig;
};